/**
 * Initialize category group toggle functionality
 * Elements with .category-group class containing a .toggle element
 * will toggle their data-open attribute between 'true' and 'false'
 */
export function initCategoryGroupToggle() {
  document.querySelectorAll('.category-group').forEach((el) => {
    const toggle = el.querySelector('.toggle')
    if (!toggle) return

    toggle.addEventListener('click', () => {
      const isOpen = el.getAttribute('data-open') === 'true'
      el.setAttribute('data-open', isOpen ? 'false' : 'true')
    })
  })
}
